import { useCallback, useEffect, useMemo } from 'react';

import { getRecordKeyFor } from '~/reducers/customerCommunicationReducer';

import fetchHeroPlannerCities from '~/actions/customerCommunication/fetchHeroPlannerCities';

import { useAppDispatch, useAppSelector } from '../store';

function useHeroPlannerCities(brand: string, countryGroupId: string, countryId: string, stateId: string) {
  const [key, params] = useMemo(() => {
    const params: Parameters<typeof fetchHeroPlannerCities> = [brand, countryGroupId, countryId, stateId];
    return [getRecordKeyFor(...params), params];
  }, [brand, countryGroupId, countryId, stateId]);
  const citiesReq = useAppSelector((state) => state.customerCommunication.countryGroupCountryStateCitiesRecords[key]);
  const appDispatch = useAppDispatch();
  const fetchCities = useCallback(() => {
    appDispatch(fetchHeroPlannerCities(...params));
  }, [appDispatch, params]);
  useEffect(() => {
    fetchCities();
  }, [fetchCities]);

  return { citiesReq, fetchCities };
}

export default useHeroPlannerCities;
